import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { connect, useDispatch, useSelector, } from "react-redux";
import { TouchableOpacity, View, FlatList, Text, ActivityIndicator } from "react-native-web";
import { getInitials } from '../../shared/core/utils';
import getUserId from '../../shared/core/GetToken';
import { AuthContext } from "../../shared/core/context";
import { LogoutUser } from "../../shared/actions/AuthActions";
import { getProxyAccessMenu } from "../../shared/actions/ProxyMenuActions";
import { Avatar, Modal, Button, Popconfirm } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getProxyListApi  } from '../../shared/actions/ProxyActions';
import { Redirect } from 'react-router-dom'
import Settings from "../../shared/config/Settings";
import IdleTimer from "../../shared/config/IdleTimer";
import { fetchProfileFromApi } from "../../shared/actions/ProfileActions"
import { appServices } from "../../shared/redux/actions/appServices";
import getUserInfo from "../../shared/core/GetTokenized";
const Sidebar = props => {
    // const { Profile, isFetching } = props.Profile;
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    // const { signOut } = React.useContext(AuthContext);
    // const { ProxyMenu, isLoadingMenu } = props.ProxyMenu;
    const { ProxyMenu, isLoadingMenu }=useSelector((state)=> state.PatientMenu)
    const { Proxy, isGettlistPrpxy } = useSelector((state)=> state.ProxyUsers)
    const {LogoutData , isLogoutLoading}= useSelector((state)=>state.Logout)
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalTop, setModalTop] = useState(0);
    const [modalLeft, setModalLeft] = useState(0);
    const [arrowClass, setArrowClass] = useState("arrow mdi mdi-chevron-right")
    const buttonRef = useRef(null); // Reference to the button
  
    const dispatch= useDispatch()
    
    // const { Proxy, isGettlistPrpxy } = props.Proxy;

    const [visible, setVisible] = useState(false);

    const [currentUser, setCurrentUser] = React.useState('');
    const [name, setName] = React.useState('');
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
      const PatienInformation = JSON.parse(information);
    const menuObj= {
        "PatientID": PatienInformation.parentid,
        "ProxyID": PatienInformation.proxyid
    }
    const breakSession = () => {
        // props.endUserSession();
        // signOut();

        getUserId().then((userInfo) => {
            const item = JSON.parse(userInfo);
            // const queryString = '?Token=' + item.token

            //console.log(queryString);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Token", item.token);
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow'
            };

            fetch(Settings.apiUrl + "Exit", requestOptions)
                .then(response => response.json())
                .then(result => {
                    // console.log(result)
                    // alert(JSON.stringify(result))
                    if (result.StatusCode == 1) {
                        // alert(result.ResponseMessage)
                        // props.endUserSession();
                        // signOut();
                        // window.location.reload();
                    } else {
                        // props.endUserSession();
                        // signOut();
                        // window.location.reload();
                    }
                })
                .catch(error => {
                    //console.log('error', error)
                    // alert("Check your network connection.")
                    // props.endUserSession();
                    // signOut();
                    // window.location.reload();
                });

        })
    }
    useEffect(() => {
        console.log(LogoutData , "logout")
        if(LogoutData){
         localStorage.clear()
        window.location.reload(); 
        }
    }, [LogoutData])
    useEffect(() => {
    if(!isModalVisible){
        setArrowClass("arrow mdi mdi-chevron-right")
        setOpen(false);
    } else{
        setArrowClass("arrowtransaform mdi mdi-chevron-right")
    }
    }, [isModalVisible])

    

    useEffect(() => {
        // props.getProxyAccessMenu()   
        dispatch(appServices.PatientMenu(menuObj))
        // getCurrentUserId()
        // getProfileInfo()
        // props.getProfile()
        dispatch(appServices.PatientProfile({
            PatientID : PatienInformation.userid
        }))
        // getPatientName(Proxy)
        dispatch(appServices.ProxyUsers({
            PatientID : PatienInformation.parentid
        }))
        // props.getProxy();
        getPatientName();
        // // props.getProfile();
        // // props.getProxy();
    }, [])
    useEffect(() => {
        console.log(Proxy , "pppppppiddd 2")
        if(Proxy){
      getPatientName(Proxy)}
    }, [Proxy])
    
    useEffect(() => {
        const timer = new IdleTimer({
            timeout: 1500, // expire after 1500ms (adjust as needed)
            onTimeout: () => {
                try {
                    // Handle timeout (e.g., logout)
                    dispatch(appServices.Logout({ PatientID: PatienInformation.parentid }));
                } catch (error) {
                    console.error('Error in onTimeout callback in useEffect:', error);
                }
            },
            onExpired: () => {
                try {
                    // Handle session expiration (e.g., logout)
                    dispatch(appServices.Logout({ PatientID: PatienInformation.parentid }));
                } catch (error) {
                    console.error('Error in onExpired callback in useEffect:', error);
                }
            }
        });
    
        return () => {
            timer.cleanUp();
        };
    }, []);
    

    const getProfileInfo = () => {
        getUserId().then((userInfo) => {
            const item = JSON.parse(userInfo);
            console.log(JSON.stringify(item))
            // name = item.parentname;

            setName(item.parentname)
            setName((state) => {
                return state;
            });
        })
        return name;
    }


    const getCurrentUserId = () => {
        getUserId().then((userInfo) => {
            const item = JSON.parse(userInfo);
            // name = item.parentname;

            setCurrentUser(item.userid)
            setCurrentUser((state) => {
                return state;
            });
        })
        return currentUser;
    }



    const _setDataState = async (proxyUserId, proxyUserName, proxyUpdateId) => {
        console.log(proxyUserId , "proxyUserId1");
        console.log(proxyUserName , "proxyUserId2");
        console.log(proxyUpdateId , "proxyUserId3");
        getUserId().then((userInfo) => {
            const item = JSON.parse(userInfo);
            _saveData(item.token, proxyUserId, proxyUserName, proxyUpdateId,)
        })

    };

    const _saveData =  (token, proxyUserId,proxyUserName, proxyUpdateId,  ) => {
        try {
            // const jsonValue = JSON.stringify({ "token": token, "userid": proxyUserId, "email": pemail, "password": ppassword, "proxy": isProxy, "username": proxyUserName, "parentid": parentid, "proxyid": proxyid, "parentname": parentname });
            const jsonValue = JSON.stringify({ "token": token, "proxyid": proxyUpdateId,  "parentid":PatienInformation.parentid, userid:proxyUserId,  "username": proxyUserName, });
            console.log(jsonValue)
             localStorage.setItem('@userToken', jsonValue)
            loadNext();
        } catch (error) {
            // Error saving data
        }
    }


    const loadNext = ( ) => {

        window.location.href = '/';
    }



    const menuNavigationRoute = (name) => {

        //diagnosis
        if (name == "Diagnosis") {
            return '/diagnosis';

        }

        // //medications
        if (name == "Treatments") {
            return '/medications';
        }

        //email or messaging
        if (name == "Messaging") {
            return '/emails'
        }


        //appointments
        if (name == "Appointments") {
            // props.navigation.navigate('Appointments')
            return '/appointments';
        }


        // //reports
        if (name == "Test Results") {
            return '/reports';
        }

        //allergies
        if (name == "Allergies") {
            return '/allergies';
            // props.navigation.navigate('Allergies')
        }


        //vitals
        if (name == "Vitals") {
            return '/vitals';
            // props.navigation.navigate('Vital')
        }

        //immunisation
        if (name == "Immunisation") {
            return '/immunisation';
            // props.navigation.navigate('Immunization')
        }


        //resources
        if (name == "Resources") {
            return '/resources';
            //   props.navigation.navigate('Resources')
        }


        //time line aka doctors notes
        if (name == 56) {
            return '/timeline';
            // props.navigation.navigate('Timeline')
        }


        //recalls aka reminders
        if (name == 29) {
            return '/reminders';
            // props.navigation.navigate('Reminder')
        }

        //letters and docs
        if (name == "Letters & Docs") {
            return '/letters';
            // props.navigation.navigate('Letters')
        }
         //service template
         if (name == "Service Template") {
            return '/servicetemplate';
            // props.navigation.navigate('Letters')
        }



    }



    const returnIcon = (name) => {

        //diagnosis
        if (name == "Diagnosis") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 512 512" width="25" fill="#665EFF" fillRule="nonzero">
                <g>
                    <path d="M256 25.961c-12.857 0-23.317 10.46-23.317 23.317S243.143 72.595 256 72.595s23.317-10.46 23.317-23.317S268.857 25.961 256 25.961zm0 31.633c-4.586 0-8.317-3.731-8.317-8.317s3.731-8.317 8.317-8.317 8.317 3.731 8.317 8.317-3.731 8.317-8.317 8.317zM186.857 81.926a7.5 7.5 0 00-7.5 7.5v12.514a7.5 7.5 0 0015 0V89.426a7.5 7.5 0 00-7.5-7.5zM325.143 81.926a7.5 7.5 0 00-7.5 7.5v12.514a7.5 7.5 0 0015 0V89.426a7.5 7.5 0 00-7.5-7.5zM278.001 95.423a7.5 7.5 0 00-10.583.71c-2.77 3.168-6.931 4.986-11.418 4.986s-8.649-1.817-11.418-4.986a7.5 7.5 0 00-10.583-.71 7.5 7.5 0 00-.711 10.583c5.619 6.428 13.897 10.114 22.712 10.114s17.093-3.687 22.712-10.114a7.5 7.5 0 00-.711-10.583zM338.671 301.476H173.329a7.5 7.5 0 000 15h165.342a7.5 7.5 0 000-15zM338.671 346.748H173.329a7.5 7.5 0 000 15h165.342a7.5 7.5 0 000-15zM338.671 392.021H173.329a7.5 7.5 0 000 15h165.342a7.5 7.5 0 000-15zM298.421 201.776h-19.104v-19.104a7.5 7.5 0 00-7.5-7.5h-31.634a7.5 7.5 0 00-7.5 7.5v19.104h-19.104a7.5 7.5 0 00-7.5 7.5v31.635a7.5 7.5 0 007.5 7.5h19.104v19.104a7.5 7.5 0 007.5 7.5h31.634a7.5 7.5 0 007.5-7.5v-19.104h19.104a7.5 7.5 0 007.5-7.5v-31.635a7.5 7.5 0 00-7.5-7.5zm-7.5 31.635h-19.104a7.5 7.5 0 00-7.5 7.5v19.104h-16.634v-19.104a7.5 7.5 0 00-7.5-7.5h-19.104v-16.635h19.104a7.5 7.5 0 007.5-7.5v-19.104h16.634v19.104a7.5 7.5 0 007.5 7.5h19.104v16.635z" />
                    <path d="M408.723 78.723h-32.042V66.936c0-12.44-10.121-22.561-22.561-22.561h-46.786C303.689 19.313 282.057 0 256 0s-47.688 19.313-51.334 44.375H157.88c-12.44 0-22.561 10.121-22.561 22.561v11.787h-32.042c-24.031 0-43.583 19.551-43.583 43.582v346.113c0 24.031 19.551 43.582 43.583 43.582h36.01a7.5 7.5 0 000-15h-36.01c-15.76 0-28.583-12.822-28.583-28.582V122.305c0-15.76 12.822-28.582 28.583-28.582h32.042v19.446h-32.042c-5.038 0-9.136 4.098-9.136 9.136v346.113c0 5.038 4.098 9.136 9.136 9.136h305.446c5.038 0 9.136-4.098 9.136-9.136V122.305c0-5.038-4.099-9.136-9.136-9.136h-32.042V93.723h32.042c15.76 0 28.583 12.822 28.583 28.582v346.113c0 15.76-12.822 28.582-28.583 28.582H169.287a7.5 7.5 0 000 15h239.436c24.031 0 43.583-19.551 43.583-43.582V122.305c0-24.031-19.551-43.582-43.583-43.582zm-5.864 49.447v334.384H109.141V128.169h26.178v1.604c0 12.44 10.121 22.561 22.561 22.561h145.407a7.5 7.5 0 000-15H157.88c-4.169 0-7.561-3.392-7.561-7.561V66.936c0-4.169 3.392-7.561 7.561-7.561h53.746a7.5 7.5 0 007.5-7.5C219.125 31.542 235.667 15 256 15s36.875 16.542 36.875 36.875a7.5 7.5 0 007.5 7.5h53.745c4.169 0 7.561 3.392 7.561 7.561v62.838c0 4.169-3.392 7.561-7.561 7.561h-20.833a7.5 7.5 0 000 15h20.833c12.44 0 22.561-10.121 22.561-22.561v-1.604h26.178z" />
                </g>
            </svg>
        }

        //medications
        if (name == "Treatments") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 512 512" width="25" fill="#3497FD" fillRule="nonzero">
                <path d="M125.696 125.994c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM215.691 312.984h-29.998v-29.998c0-5.522-4.478-10-10-10s-9.999 4.478-9.999 10v29.998h-29.998c-5.522 0-10 4.478-10 9.999s4.478 10 10 10h29.998v29.998c0 5.522 4.478 10 9.999 10s10-4.478 10-10v-29.998h29.998c5.522 0 10-4.478 10-10s-4.477-9.999-10-9.999z" />
                <path d="M485.578 321.984c-22.105-38.286-70.981-51.389-109.274-29.279l-40.618 23.45v-86.836c0-10.735-3.55-21.388-9.999-29.998L275.69 132.66v-28.386c11.638-4.128 19.999-15.242 19.999-28.279V29.998C295.687 13.457 282.23 0 265.689 0H85.698C69.157 0 55.699 13.457 55.699 29.998v45.998c0 13.035 8.361 24.151 19.999 28.279v28.386l-50.001 66.665c-6.446 8.606-9.996 19.258-9.996 29.993v193.66c0 27.569 22.429 49.997 49.997 49.997H226.4c22.421 37.583 70.767 50.161 108.664 28.279L456.3 431.258c37.955-21.918 51.494-70.779 29.278-109.274zM75.698 29.998c0-5.514 4.486-10 9.999-10h179.991c5.514 0 10 4.486 10 10v45.998c0 5.514-4.486 9.999-10 9.999H85.698c-5.514 0-9.999-4.486-9.999-9.999V29.998zM41.701 211.319l51.996-69.326a9.999 9.999 0 002-6v-29.998h159.992v19.999h-89.995c-5.522 0-10 4.478-10 10s4.478 10 10 10h94.995l48.993 65.322c3.202 4.275 5.191 9.39 5.792 14.674H35.913c.6-5.285 2.589-10.4 5.788-14.671zm23.998 241.658c-16.541 0-29.998-13.457-29.998-29.998V412.88h181.675c-3.171 12.965-3.15 26.813.481 40.098H65.699zm159.52-59.997H35.7V245.987h279.986V327.7l-60.619 35.002c-12.639 7.301-22.855 17.694-29.848 30.278zm99.847 90.955c-28.697 16.571-65.367 6.771-81.949-21.946-16.661-28.994-6.564-65.498 21.952-81.969l54.277-31.338 59.997 103.915-54.277 31.338zM446.3 413.939l-49.637 28.659-59.998-103.917 49.638-28.656c28.716-16.578 65.373-6.761 81.955 21.957 16.655 28.862 6.527 65.508-21.958 81.957z" />
            </svg>
        }

        //email or messaging
        if (name == "Messaging") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 512 512" width="25" fill="#5773FF" fillRule="nonzero" >
                <path d="M444.555 191.141h-238a7.5 7.5 0 000 15h238a7.5 7.5 0 000-15zM444.555 248.474h-238a7.5 7.5 0 000 15h238a7.5 7.5 0 000-15zM444.555 305.807h-238a7.5 7.5 0 000 15h238a7.5 7.5 0 000-15z" />
                <path d="M468.378 125.549H182.732c-24.053 0-43.622 19.568-43.622 43.622v179.617c0 24.053 19.568 43.622 43.622 43.622h200.211c2.141 0 4.13.963 5.458 2.644l64.655 81.853c2.548 3.226 6.266 4.984 10.159 4.984 1.447 0 2.919-.243 4.363-.745 5.327-1.85 8.769-6.689 8.769-12.328v-77.153C496.572 387.887 512 370.006 512 348.788V169.17c0-24.053-19.568-43.621-43.622-43.621zM497 348.788c0 15.577-12.673 28.412-28.25 28.61a7.5 7.5 0 00-7.404 7.5v78.305l-61.174-77.447c-4.189-5.305-10.469-8.347-17.229-8.347H182.732c-15.782 0-28.622-12.84-28.622-28.622V169.17c0-15.782 12.839-28.622 28.622-28.622h285.646c15.782 0 28.622 12.84 28.622 28.622z" />
                <path d="M110.494 249.561a19.997 19.997 0 00-12.936 7.435l-51.521 65.226v-65.371a7.5 7.5 0 00-7.404-7.5C25.602 249.185 15 238.448 15 225.416V69.055C15 55.852 25.742 45.11 38.945 45.11h248.663c13.203 0 23.945 10.742 23.945 23.945v28.932a7.5 7.5 0 0015 0V69.055c0-21.474-17.471-38.945-38.945-38.945H38.945C17.471 30.11 0 47.581 0 69.055v156.361c0 18.667 13.371 34.438 31.038 38.124v66.366c0 5.328 3.252 9.901 8.286 11.649 1.365.474 2.755.704 4.123.704 3.677 0 7.192-1.662 9.599-4.709l56.284-71.256a5.061 5.061 0 013.273-1.882 7.5 7.5 0 006.371-8.48 7.495 7.495 0 00-8.48-6.371z" />
            </svg>
        }


        //appointments
        if (name == "Appointments") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 60 60" width="25" fill="#3ACCE1" fillRule="nonzero" >
                <path d="M57 6h-2a3 3 0 00-3-3h-4a3 3 0 00-6 0h-4a3 3 0 00-6 0h-4a3 3 0 00-6 0h-4a3 3 0 00-6 0H8a3 3 0 00-3 3H3a3 3 0 00-3 3v48a3 3 0 003 3h54a3 3 0 003-3V9a3 3 0 00-3-3zM7 49.816c.32.118.659.18 1 .184h44c.341-.003.68-.066 1-.184V52a1 1 0 01-1 1H8a1 1 0 01-1-1zM52 48H8a1 1 0 01-1-1V13h46v34a1 1 0 01-1 1zM44 3a1 1 0 012 0v3a1 1 0 01-2 0zM34 3a1 1 0 012 0v3a1 1 0 01-2 0zM24 3a1 1 0 012 0v3a1 1 0 01-2 0zM14 3a1 1 0 012 0v3a1 1 0 01-2 0zM8 5h4v1a3 3 0 006 0V5h4v1a3 3 0 006 0V5h4v1a3 3 0 006 0V5h4v1a3 3 0 006 0V5h4a1 1 0 011 1v5H7V6a1 1 0 011-1zm50 52a1 1 0 01-1 1H3a1 1 0 01-1-1V9a1 1 0 011-1h2v44a3 3 0 003 3h44a3 3 0 003-3V8h2a1 1 0 011 1z" />
                <path d="M47 16h-1a1 1 0 000 2h1v5a3 3 0 01-6 0v-5h1a1 1 0 000-2h-1a2 2 0 00-2 2v5a5.009 5.009 0 004 4.9V30c0 7.18-5.82 13-13 13s-13-5.82-13-13c.004-1.762.37-3.504 1.076-5.118a4.028 4.028 0 10-1.767-.942A14.855 14.855 0 0015 30c0 8.284 6.716 15 15 15s15-6.716 15-15v-2.1a5.009 5.009 0 004-4.9v-5a2 2 0 00-2-2zm-28 3a2 2 0 110 4 2 2 0 010-4z" />
                <path d="M27.293 35.707A1 1 0 0028 36a.844.844 0 00.087 0 1 1 0 00.732-.423l7-10a1 1 0 00-1.638-1.146l-6.317 9.019-2.157-2.157a1 1 0 00-1.414 1.414z" />
            </svg>
        }


        //reports
        if (name == "Test Results") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 64 64" width="25" fill="#FF4F9A" fillRule="nonzero">
                <path d="M46 32a4 4 0 01-4-4h-2a6 6 0 0012 0h-2a4 4 0 01-4 4z" />
                <path d="M53 36h-.1A12.987 12.987 0 0059 25v-5h1a1 1 0 001-1v-2a14.98 14.98 0 00-26.97-9H3a1 1 0 00-1 1v52a1 1 0 001 1h58a1 1 0 001-1V45a9.014 9.014 0 00-9-9zm0 9v2h-2v-2zM33 17a13 13 0 0126 0v1h-.59l-3.95-3.96a4.981 4.981 0 00-5.12-1.21L33.84 18H33zm-2.94 27a8.262 8.262 0 00-.06 1v3H20v2h10v4H20v2h10v4H4V10h28.74A14.873 14.873 0 0031 17v2a1 1 0 001 1h1v5a12.987 12.987 0 006.1 11H39a8.991 8.991 0 00-8.47 6H20v2zM45 60H32V45a7 7 0 016-6.92V47h-2a1 1 0 00-1 1v6h2v-5h4v5h2v-6a1 1 0 00-1-1h-2v-9h5zM35 25v-5.28l14.97-4.99a2.985 2.985 0 013.07.73L57 19.41V25a11 11 0 01-22 0zm25 35H47V38h4v5h-1a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-1v-5a7.008 7.008 0 017 7z" />
                <path d="M40 20h2v4h-2zM50 20h2v4h-2zM28 18h-3v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3h-3a1 1 0 00-1 1v4a1 1 0 001 1h3v3a1 1 0 001 1h4a1 1 0 001-1v-3h3a1 1 0 001-1v-4a1 1 0 00-1-1zm-1 4h-3a1 1 0 00-1 1v3h-2v-3a1 1 0 00-1-1h-3v-2h3a1 1 0 001-1v-3h2v3a1 1 0 001 1h3zM9 18a3.009 3.009 0 00-3 3v31a1.185 1.185 0 00.05.32l2 6a1 1 0 001.9 0l2-6A1.185 1.185 0 0012 52V21a3.009 3.009 0 00-3-3zm0 36.84L8.39 53h1.22zM10 51H8V21a1 1 0 012 0zM14 30h4v2h-4zM20 30h11v2H20zM14 36h4v2h-4zM20 36h11v2H20zM14 42h4v2h-4zM14 48h4v2h-4zM14 54h4v2h-4z" />
            </svg>
        }

        //allergies
        if (name == "Allergies") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 511 511" width="25" fill="#C840E9" fillRule="nonzero " >
                <path d="M436.428 74.879C388.142 26.593 323.941 0 255.654 0 197.81 0 143.244 18.845 97.857 54.497a7.5 7.5 0 009.266 11.796C149.842 32.737 201.203 15 255.654 15c64.281 0 124.714 25.032 170.168 70.486s70.486 105.887 70.486 170.168-25.032 124.714-70.486 170.168-105.887 70.486-170.168 70.486-124.714-25.032-170.168-70.486S15 319.935 15 255.654c0-63.467 24.504-123.359 68.997-168.643a7.5 7.5 0 00-10.699-10.513C26.031 124.604 0 188.229 0 255.654c0 68.288 26.593 132.488 74.879 180.774s112.487 74.879 180.774 74.879 132.488-26.593 180.774-74.879 74.879-112.487 74.879-180.774-26.591-132.488-74.878-180.775z" />
                <path d="M121.383 124.762c17.713-18.175 38.453-32.369 61.644-42.189 24.069-10.191 49.608-15.137 75.88-14.686a187.995 187.995 0 0146.965 6.768 7.5 7.5 0 004.004-14.456 203.04 203.04 0 00-50.714-7.31c-28.394-.481-55.973 4.858-81.984 15.872-25.038 10.602-47.424 25.921-66.537 45.532-19.124 19.622-33.871 42.412-43.831 67.735-10.346 26.304-14.976 54.034-13.763 82.421 1.219 28.527 8.258 55.905 20.921 81.371a14.043 14.043 0 009.409 7.447 13.998 13.998 0 0011.7-2.504L390.011 126.18a13.986 13.986 0 005.519-10.605 14.077 14.077 0 00-4.699-11.078 202.91 202.91 0 00-49.706-32.777 7.5 7.5 0 10-6.332 13.598 187.9 187.9 0 0145.213 29.626l-55.83 42.513c-11.328-7.855-23.725-13.61-36.802-17.159l3.075-19.038a7.5 7.5 0 00-14.808-2.392l-2.975 18.418a122.402 122.402 0 00-17.013-1.204c-7.41 0-14.807.679-22.066 2.023l-5.485-11.579a20.788 20.788 0 003.247-20.754c-4.19-10.688-16.296-15.974-26.983-11.786l-20.696 8.113c-10.688 4.189-15.976 16.294-11.787 26.983a20.81 20.81 0 0015.379 12.825l4.022 12.786a120.717 120.717 0 00-20.128 15.959l-11.033-6.551a20.79 20.79 0 00-8.898-19.028 20.682 20.682 0 00-15.579-3.352 20.681 20.681 0 00-13.386 8.646l-12.637 18.289c-3.162 4.575-4.352 10.108-3.352 15.579s4.07 10.225 8.646 13.386a20.802 20.802 0 0019.918 2.048l10.467 8.352a119.726 119.726 0 00-6.822 20.138l-12.806.253a20.79 20.79 0 00-17.596-11.473 20.688 20.688 0 00-15.004 5.37 20.683 20.683 0 00-6.812 14.405l-1.089 22.204c-.272 5.554 1.635 10.882 5.37 15.003s8.851 6.54 14.406 6.813a20.842 20.842 0 0018.003-8.766l13.315 1.576a119.814 119.814 0 005.526 22.793l-54.892 41.798c-11.409-23.287-17.756-48.287-18.869-74.326-1.123-26.28 3.162-51.948 12.736-76.29 9.227-23.457 22.891-44.571 40.615-62.757zm74.768 122.355c-6.111-9.421-2.217-22.836 8.681-29.905 5.406-3.506 11.666-4.923 17.62-3.986 5.653.888 10.351 3.819 13.227 8.253.495.763.909 1.568 1.279 2.394l-36.515 27.805a17.773 17.773 0 01-4.292-4.561zm-45.639 19.012a7.5 7.5 0 00-6.589-6.784l-24.371-2.885a7.492 7.492 0 00-8.042 5.214 5.8 5.8 0 01-5.827 4.077 5.825 5.825 0 01-5.527-6.098l1.089-22.204c.076-1.553.752-2.983 1.904-4.027s2.642-1.578 4.195-1.5a5.801 5.801 0 015.475 5.057c.489 3.798 3.776 6.611 7.587 6.541l24.302-.481a7.499 7.499 0 007.221-6.106 104.79 104.79 0 019.385-27.701 7.501 7.501 0 00-2.021-9.237l-19.167-15.293a7.503 7.503 0 00-9.582.188 5.81 5.81 0 01-9.518-3.351 5.784 5.784 0 01.938-4.355l12.637-18.289a5.783 5.783 0 013.742-2.417 5.774 5.774 0 014.355.937 5.802 5.802 0 011.984 7.185 7.5 7.5 0 002.996 9.559l20.916 12.418a7.498 7.498 0 009.349-1.371 105.834 105.834 0 0125.957-20.579 7.5 7.5 0 003.471-8.784l-7.359-23.396a7.495 7.495 0 00-8.054-5.195 5.808 5.808 0 01-6.107-3.642 5.827 5.827 0 013.295-7.543l20.696-8.113a5.828 5.828 0 017.543 3.295 5.802 5.802 0 01-2.367 7.068 7.5 7.5 0 00-2.854 9.602l10.403 21.96a7.498 7.498 0 008.517 4.084 106.088 106.088 0 0124.57-2.88c20.031 0 39.151 5.517 55.873 16.006l-62.456 47.558a33.006 33.006 0 00-.808-1.332c-5.225-8.056-13.564-13.351-23.482-14.909-9.616-1.509-19.598.698-28.112 6.22-17.836 11.57-23.714 34.292-13.103 50.652a32.507 32.507 0 004.696 5.672l-33.82 25.753a104.842 104.842 0 01-3.93-20.574zM389.924 386.546c-17.713 18.175-38.454 32.37-61.644 42.188-24.069 10.191-49.606 15.134-75.88 14.686a189.46 189.46 0 01-26.156-2.265 7.498 7.498 0 00-8.574 6.243 7.499 7.499 0 006.243 8.574 204.658 204.658 0 0031.756 2.475c27.147 0 53.526-5.344 78.459-15.901 25.038-10.602 47.424-25.92 66.538-45.532 19.124-19.622 33.871-42.411 43.831-67.735 10.346-26.304 14.977-54.035 13.764-82.421-1.219-28.528-8.258-55.905-20.921-81.372a14.04 14.04 0 00-9.409-7.446 13.985 13.985 0 00-11.699 2.503L121.297 385.127a13.986 13.986 0 00-5.519 10.605 14.077 14.077 0 004.699 11.078c20.808 18.622 44.739 32.516 71.13 41.298a7.498 7.498 0 009.484-4.748 7.5 7.5 0 00-4.748-9.484c-24.087-8.016-45.964-20.634-65.042-37.513l54.468-41.476a120.888 120.888 0 0012.398 7.771l-4.306 11.701a7.5 7.5 0 1014.077 5.18l3.881-10.548a119.795 119.795 0 0029.551 7.387l1.785 12.698a20.788 20.788 0 00-9.287 18.841 20.688 20.688 0 007.125 14.254c3.82 3.313 8.604 5.094 13.611 5.094.5 0 1.002-.018 1.506-.054l22.174-1.573c11.451-.812 20.107-10.79 19.294-22.242a20.809 20.809 0 00-10.855-16.826l-.027-13.39a119.61 119.61 0 0023.988-9.227l8.561 9.523a20.788 20.788 0 002.82 20.816 20.685 20.685 0 0013.871 7.844 20.68 20.68 0 0015.354-4.261l17.515-13.689c9.045-7.07 10.652-20.18 3.583-29.226a20.8 20.8 0 00-18.402-7.895l-7.516-11.115a120.813 120.813 0 0012.524-17.167l12.306 3.578a20.786 20.786 0 0013.375 16.198 20.68 20.68 0 0015.922-.652 20.684 20.684 0 0010.797-11.719l7.66-20.869c3.956-10.777-1.594-22.764-12.372-26.719a20.805 20.805 0 00-19.798 2.999l-12.235-5.472a121.52 121.52 0 001.574-19.475c0-2.726-.097-5.438-.276-8.136l12.646-1.849a7.499 7.499 0 006.336-8.506 7.497 7.497 0 00-8.506-6.336l-12.396 1.813a119.323 119.323 0 00-5.057-18.255l55.435-42.212c11.409 23.287 17.756 48.287 18.869 74.327 1.123 26.28-3.162 51.948-12.736 76.291-9.226 23.458-22.891 44.572-40.614 62.757zM327.48 255.654c0 8.549-6.955 15.504-15.504 15.504-4.023 0-7.817-1.584-10.652-4.263l24.317-18.517a15.449 15.449 0 011.839 7.276zm33.744 1c0 7.501-.798 15.013-2.372 22.326a7.498 7.498 0 004.27 8.424l22.386 10.013a7.5 7.5 0 009.23-2.58 5.81 5.81 0 016.777-2.154 5.826 5.826 0 013.458 7.469l-7.66 20.869a5.829 5.829 0 01-7.47 3.458 5.8 5.8 0 01-3.718-6.459 7.498 7.498 0 00-5.292-8.505l-23.336-6.785a7.496 7.496 0 00-8.706 3.663 105.842 105.842 0 01-17.245 23.638 7.499 7.499 0 00-.822 9.415l13.75 20.333a7.499 7.499 0 009.202 2.677 5.808 5.808 0 016.895 1.745 5.828 5.828 0 01-1.001 8.17l-17.515 13.689a5.77 5.77 0 01-4.292 1.191 5.78 5.78 0 01-3.877-2.193 5.801 5.801 0 01.249-7.45 7.5 7.5 0 00-.01-10.017l-16.248-18.074a7.498 7.498 0 00-9.34-1.474 104.737 104.737 0 01-30.903 11.886 7.5 7.5 0 00-5.947 7.353l.049 24.522a7.5 7.5 0 006.138 7.36 5.808 5.808 0 014.744 5.297 5.825 5.825 0 01-5.394 6.217l-22.175 1.574a5.81 5.81 0 01-4.225-1.409 5.78 5.78 0 01-1.992-3.985 5.8 5.8 0 014.367-6.041 7.499 7.499 0 005.586-8.314l-3.385-24.086a7.499 7.499 0 00-6.925-6.439 104.737 104.737 0 01-50.124-16.668l90.975-69.275c5.699 6.321 13.9 10.126 22.651 10.126 16.82 0 30.504-13.684 30.504-30.504 0-5.9-1.707-11.577-4.815-16.431l18.714-14.25c3.212 10.198 4.844 20.814 4.844 31.678z" />
                <path d="M282.29 299.682c-12.687 0-23.008 10.321-23.008 23.008s10.321 23.008 23.008 23.008 23.008-10.321 23.008-23.008-10.321-23.008-23.008-23.008zm0 31.016c-4.416 0-8.008-3.592-8.008-8.008s3.592-8.008 8.008-8.008 8.008 3.592 8.008 8.008-3.592 8.008-8.008 8.008z" />
            </svg>
        }


        //vitals
        if (name == "Vitals") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 512 512" width="25" fill="#665EFF" fillRule="nonzero">
                <path d="M504.489 392.012a7.51 7.51 0 00-7.511 7.511c0 15.186-12.354 27.54-27.54 27.54H42.562c-15.186 0-27.54-12.355-27.54-27.54V112.477c0-15.186 12.355-27.54 27.54-27.54h238.867c4.149 0 7.511-3.363 7.511-7.511s-3.362-7.511-7.511-7.511H42.562C19.093 69.915 0 89.008 0 112.477v287.045c0 23.469 19.093 42.562 42.562 42.562h426.875c23.469 0 42.562-19.093 42.562-42.562a7.509 7.509 0 00-7.51-7.51zM469.438 69.915H317.182c-4.149 0-7.511 3.363-7.511 7.511s3.362 7.511 7.511 7.511h152.255c15.185 0 27.54 12.355 27.54 27.54V363.5c0 4.148 3.362 7.511 7.511 7.511s7.511-3.363 7.511-7.511V112.477c.001-23.469-19.092-42.562-42.561-42.562z" />
                <path d="M378.282 299.944V148.503c0-10.768-8.761-19.529-19.529-19.529H149.528a7.511 7.511 0 000 15.022h209.225a4.512 4.512 0 014.507 4.507v64.311h-30.648l-11.886-11.885c-1.986-1.987-4.627-3.081-7.437-3.081s-5.45 1.094-7.436 3.08l-31.496 31.496-12.076-12.077c-1.986-1.987-4.628-3.081-7.437-3.081s-5.449 1.094-7.436 3.08l-20.368 20.368-54.103-54.103c-1.986-1.986-4.627-3.08-7.436-3.08s-5.45 1.094-7.435 3.08l-26.201 26.2H83.387v-64.309a4.512 4.512 0 014.507-4.507h24.28a7.511 7.511 0 000-15.022h-24.28c-10.768 0-19.529 8.76-19.529 19.529v151.441c0 10.768 8.76 19.529 19.529 19.529h270.859c10.768 0 19.529-8.76 19.529-19.528zm-294.895 0v-72.11h50.344c2.81 0 5.452-1.095 7.436-3.08l24.334-24.333 54.104 54.104a10.484 10.484 0 007.435 3.074c2.692 0 5.386-1.025 7.435-3.075l20.369-20.368 12.079 12.079c4.098 4.098 10.769 4.098 14.87-.001l31.495-31.496 10.02 10.02a10.448 10.448 0 007.436 3.08h32.515v72.108a4.512 4.512 0 01-4.507 4.507H87.894a4.516 4.516 0 01-4.507-4.509zM234.841 369.792c0 16.877 13.73 30.607 30.607 30.607s30.607-13.731 30.607-30.607-13.73-30.607-30.607-30.607c-16.877-.001-30.607 13.73-30.607 30.607zm46.192 0c0 8.594-6.992 15.585-15.585 15.585-8.594 0-15.585-6.992-15.585-15.585s6.991-15.585 15.585-15.585c8.593-.001 15.585 6.991 15.585 15.585zM125.458 359.083c-4.351-11.61-15.559-19.898-28.67-19.898-16.877 0-30.607 13.731-30.607 30.607s13.731 30.607 30.607 30.607c13.111 0 24.319-8.288 28.67-19.898 4.351 11.61 15.559 19.898 28.67 19.898 16.877 0 30.607-13.731 30.607-30.607s-13.731-30.607-30.607-30.607c-13.111-.001-24.319 8.288-28.67 19.898zm-28.67 26.294c-8.594 0-15.585-6.992-15.585-15.585s6.992-15.585 15.585-15.585 15.585 6.992 15.585 15.585-6.991 15.585-15.585 15.585zm72.925-15.585c0 8.594-6.992 15.585-15.585 15.585s-15.585-6.992-15.585-15.585 6.992-15.585 15.585-15.585 15.585 6.991 15.585 15.585z" />
            </svg>
        }

        //immunisation
        if (name == "Immunisation") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 509.703 509.703" width="25" fill="#3ACCE1" fillRule="nonzero" >
                <path d="M257.087 197.99h-41.4v26.342h-27.058v40.7h27.058v26.342h41.4v-26.342h27.058v-40.7h-27.058zm12.059 41.342v10.7h-27.058v26.342h-11.4v-26.342H203.63v-10.7h27.058V212.99h11.4v26.342zM107.302 60.825h15V43.351h17.474v-15h-17.474V10.878h-15v17.473H89.829v15h17.473zM32.474 123.689h-15v17.473H0v15h17.474v17.474h15v-17.474h17.473v-15H32.474zM32.166 53.325h15v15h-15z" />
                <path d="M505.071 322.906c-7.138-10.857-21.167-15.67-33.464-11.384-12.551 4.374-20.617 17.141-19.135 30.363l-15.248 7.133c-5.536-8.397-13.239-15.363-22.5-19.986l4.105-8.321c11.738 1.22 23.22-6.179 26.518-17.591 3.213-11.114-2.247-23.077-12.491-28.298-10.348-5.274-23.405-2.588-30.761 6.41-8.19 10.018-6.828 25.025 2.953 33.508l-4.621 9.366a57.946 57.946 0 00-12.918-1.15l2.334-1.629V118.11L236.388 63.273 82.931 118.11v203.217l153.456 107.13 98.488-68.755c-4.254 10.833-5.168 22.826-2.55 34.171l-10.977 4.35c-8.344-9.732-23.27-11.464-33.644-3.991-9.511 6.851-12.915 19.843-7.646 30.381 5.277 10.554 17.742 15.904 29.07 12.745 11.071-3.087 18.851-13.749 17.977-25.281l10.442-4.138a58.218 58.218 0 0021.181 22.54l-6.288 14.543c-11.724-1.559-23.462 4.984-28.28 15.79-5.833 13.081-.118 28.936 12.725 35.266 11.42 5.628 25.558 2.383 33.383-7.643 8.867-11.361 7.008-28.208-4.075-37.424l6.259-14.476c12.318 3.619 25.632 3.096 37.585-1.627l5.54 10.254c-7.731 7.929-8.942 20.377-3.207 29.795 6.521 10.71 20.583 15.145 31.964 9.716 10.577-5.045 15.888-17.3 12.724-28.501-3.413-12.083-15.762-19.974-28.171-17.933l-5.719-10.585c20.096-14.728 28.591-41.503 20.625-65.146l14.225-6.655c9.257 12.415 27.3 15.149 39.856 6.113 12.306-8.857 15.535-26.377 7.197-39.06zm-83.611-36.908c14.103 0 13.91 20.945 0 20.945-13.896 0-14.126-20.945 0-20.945zM302.356 424.372c-14.103 0-13.91-20.945 0-20.945 13.897 0 14.127 20.945 0 20.945zm58.365 49.911c-2.083 10.038-15.528 12.91-21.568 4.64-6.397-8.759 1.63-21.08 12.188-18.892 6.435 1.333 10.719 7.795 9.38 14.252zm-31.772-208.129c-7.818 7.597-10.658 19.436-7.134 29.747l-85.428 59.638-93.872-65.533V162.983l93.872-32.011 93.872 32.011v101.952l-1.31 1.219zm8.641 28.094a13.796 13.796 0 01-2.002-10.357c2.559-12.347 20.091-14.732 25.781-3.288 7.417 14.915-14.567 27.541-23.779 13.645zm28.07 15.881c3.96-2.794 7.091-6.468 9.184-10.725v14.101l-6.146 4.29zM236.388 410.163L97.931 313.505V128.678l138.456-49.477 138.456 49.477v145.365c-5.398-10.957-17.446-17.451-29.585-15.83V152.25l-108.872-37.125-108.87 37.125v145.58l108.872 76.004 93.796-65.481c5.838 5.09 13.68 7.612 21.39 6.947l4.485 11.319zm196.554 41.645c13.924 0 14.701 21.849.432 21.311-13.262-.499-14.335-21.311-.432-21.311zm-2.014-62.159c-3.999 19.285-21.237 33.787-40.978 34.264-17.743.429-34.254-10.416-40.944-26.838-6.533-16.037-2.55-34.954 9.896-46.997 12.838-12.422 32.553-15.659 48.664-7.858 17.509 8.479 27.31 28.386 23.362 47.429zm63.58-48.187c-2.375 11.458-17.766 14.692-24.601 5.225-7.191-9.959 1.894-23.945 13.923-21.453 7.31 1.515 12.197 8.902 10.678 16.228z" />
                <path d="M365.247 363.107h15v15h-15zM172.369 173.895v15h-15v-15zm0 30v15h-15v-15z" />
            </svg>
        }


        //resources
        if (name == "Resources") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 64 64" width="25" fill="#FDC70C" fillRule="nonzero">
                <path d="M61 24h-1V9a3.009 3.009 0 00-3-3H45V5a3.009 3.009 0 00-3-3H12a3.009 3.009 0 00-3 3v1H8a3.009 3.009 0 00-3 3v5H3a1 1 0 00-1 1v46a1 1 0 001 1h58a1 1 0 001-1V25a1 1 0 00-1-1zM45 12h9v4h-9zm0 6h10a1 1 0 001-1v-6a1 1 0 00-1-1H45V8h12a1 1 0 011 1v15H45zM35 4h4v9.13l-1.45-.96a.975.975 0 00-1.1 0l-1.45.96zM11 5a1 1 0 011-1h21v11a.984.984 0 00.53.88.963.963 0 001.02-.05L37 14.2l2.45 1.63A1 1 0 0041 15V4h1a1 1 0 011 1v19h-9.32l-3.75-9.37A1 1 0 0029 14H11zM7 9a1 1 0 011-1h1v6H7zm-3 7h24.32l3.2 8H4zm56 44H4V26h56z" />
                <path d="M13 6h18v2H13zM13 10h18v2H13zM57 28H7a1 1 0 00-1 1v28a1 1 0 001 1h50a1 1 0 001-1V29a1 1 0 00-1-1zm-1 28H8V30h48z" />
                <path d="M32 32a11 11 0 1011 11 11.007 11.007 0 00-11-11zm0 20a9 9 0 119-9 9.014 9.014 0 01-9 9z" />
                <path d="M38 40h-3v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3h-3a1 1 0 00-1 1v4a1 1 0 001 1h3v3a1 1 0 001 1h4a1 1 0 001-1v-3h3a1 1 0 001-1v-4a1 1 0 00-1-1zm-1 4h-3a1 1 0 00-1 1v3h-2v-3a1 1 0 00-1-1h-3v-2h3a1 1 0 001-1v-3h2v3a1 1 0 001 1h3z" />
            </svg>
        }


        //time line aka doctors notes
        if (name == 56) {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 459 459" width="25" fill="#FF4F9A" fillRule="nonzero" >
                <path d="M173.322 114.954c-.019.358-.019.716 0 1.074.297 5.474 4.975 9.672 10.449 9.375h175.02c.358.019.716.019 1.074 0 5.474-.297 9.672-4.975 9.375-10.449V10.464c.019-.358.019-.716 0-1.074-.297-5.474-4.975-9.672-10.449-9.375h-175.02a10.125 10.125 0 00-1.074 0c-5.474.297-9.672 4.975-9.375 10.449v104.49zm20.898-94.041h154.122v83.592H194.22V20.913zM421.486 282.137v-104.49c.019-.358.019-.716 0-1.074-.297-5.474-4.975-9.672-10.449-9.375H183.771a10.125 10.125 0 00-1.074 0c-5.474.297-9.672 4.975-9.375 10.449v104.49c-.019.358-.019.716 0 1.074.297 5.474 4.975 9.672 10.449 9.375h227.265c.358.019.716.019 1.074 0 5.475-.296 9.672-4.975 9.376-10.449zm-20.898-10.449H194.22v-83.592h206.367v83.592zM369.241 344.831c.019-.358.019-.716 0-1.074-.297-5.474-4.975-9.672-10.449-9.375h-175.02a10.125 10.125 0 00-1.074 0c-5.474.297-9.672 4.975-9.375 10.449v104.49c-.019.358-.019.716 0 1.074.297 5.474 4.975 9.672 10.449 9.375h175.02c.358.019.716.019 1.074 0 5.474-.297 9.672-4.975 9.375-10.449v-104.49zm-20.898 94.041H194.22V355.28h154.122v83.592zM129.384 46.565c-5.482-24.497-29.785-39.912-54.282-34.429C54.356 16.778 39.6 35.181 39.575 56.439c-.533 21.12 13.888 39.692 34.482 44.408v84.637c-24.526 5.352-40.07 29.572-34.718 54.098A45.453 45.453 0 0074.057 274.3v84.637c-20.594 4.716-35.015 23.288-34.482 44.408.029 25.103 20.402 45.43 45.505 45.401 25.103-.029 45.43-20.402 45.401-45.505-.024-21.259-14.781-39.661-35.526-44.304V274.3c20.688-4.684 35.281-23.199 35.004-44.408.277-21.21-14.316-39.724-35.004-44.408v-84.637c24.497-5.482 39.912-29.785 34.429-54.282zm-19.278 356.78c-.284 13.645-11.429 24.558-25.078 24.555-13.561 0-24.555-10.994-24.555-24.555s10.994-24.555 24.555-24.555c13.649-.003 24.794 10.91 25.078 24.555zm-.507-173.468c.009 13.561-10.978 24.562-24.539 24.571h-.031c-13.357-.284-24.036-11.195-24.033-24.555-.003-13.36 10.676-24.271 24.033-24.555 13.561-.009 24.562 10.977 24.57 24.539zM85.028 80.994c-13.357-.284-24.035-11.195-24.032-24.555-.003-13.36 10.676-24.271 24.033-24.555 13.648-.003 24.793 10.91 25.078 24.555-.285 13.646-11.43 24.558-25.079 24.555z" />
                <path d="M215.118 57.484H275.2c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-60.082c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449zM327.445 67.933H215.118c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h112.327c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449zM215.118 224.668H275.2c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-60.082c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449zM215.118 256.015h112.327c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449H215.118c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449zM215.118 391.852H275.2c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-60.082c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449zM215.118 423.198h112.327c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449H215.118c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449z" />
            </svg>
        }


        //recalls aka reminders
        if (name == 29) {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="-4 0 361 361.813" width="25" fill="#FF9057" fillRule="nonzero">
                <path d="M353.965 143.36c0-36.852-29.985-66.837-66.84-66.837-8.195 0-16.02 1.555-23.281 4.27-18.797-22.527-44.215-37.734-72.29-43.746v-6.328C191.555 13.78 177.775 0 160.833 0c-16.937 0-30.719 13.781-30.719 30.719v8.125C75.125 53.883 34.54 104.148 34.54 163.84v102.398h-3.414c-16.938 0-30.719 13.782-30.719 30.723 0 16.937 13.781 30.719 30.719 30.719h93.39c4.622 19.832 22.157 34.133 43.145 34.133 20.988 0 38.528-14.301 43.145-34.133h86.562c16.942 0 30.719-13.782 30.719-30.72 0-16.94-13.777-30.722-30.719-30.722h-3.414v-56.386c33.66-3.434 60.012-31.942 60.012-66.493zm-13.652 0c0 29.327-23.86 53.183-53.188 53.183-29.324 0-53.184-23.856-53.184-53.184s23.86-53.183 53.184-53.183c29.328 0 53.188 23.855 53.188 53.183zM143.766 30.718c0-9.41 7.652-17.067 17.066-17.067 9.414 0 17.066 7.657 17.066 17.067v4.148a130.884 130.884 0 00-13.652-.734c-6.984 0-13.789.71-20.48 1.777zM167.66 348.16c-13.379 0-24.656-8.437-28.875-20.48h57.75c-4.219 12.043-15.496 20.48-28.875 20.48zm129.707-68.265c9.414 0 17.067 7.656 17.067 17.066s-7.653 17.066-17.067 17.066H31.125c-9.414 0-17.066-7.656-17.066-17.066s7.652-17.066 17.066-17.066h10.242a6.824 6.824 0 006.824-6.829V163.84c0-63.992 52.063-116.055 116.055-116.055 33.469 0 64.816 14.363 86.883 39.352-18.52 11.894-30.844 32.629-30.844 56.222 0 34.551 26.356 63.059 60.012 66.493v63.214a6.828 6.828 0 006.828 6.829zm0 0" />
                <path d="M268.86 168.45a6.812 6.812 0 004.827-2l18.266-18.262a6.83 6.83 0 002-4.829v-26.093c0-3.77-3.055-6.825-6.828-6.825s-6.824 3.055-6.824 6.825v23.27l-16.266 16.26a6.82 6.82 0 000 9.653 6.787 6.787 0 004.824 2zm0 0M184.727 266.238h-13.653a6.828 6.828 0 00-6.828 6.828 6.828 6.828 0 006.828 6.829h13.653a6.828 6.828 0 006.828-6.829 6.828 6.828 0 00-6.828-6.828zm0 0M146.04 266.238H75.5a6.828 6.828 0 00-6.828 6.828 6.828 6.828 0 006.828 6.829h70.54a6.828 6.828 0 006.827-6.829 6.828 6.828 0 00-6.828-6.828zm0 0" />
            </svg>
        }

        //letters and docs
        if (name == "Letters & Docs") {
            return <svg style={{ marginRight: 10 }} height="25" viewBox="0 0 480.013 480.013" width="25" fill="#3497FD" fillRule="nonzero">
                <path d="M238.068 322.013c0 57.897 47.103 105 105 105s105-47.103 105-105c0-37.745-20.022-70.896-50-89.406V101.013a7.982 7.982 0 00-3.19-6.382C295.481-4.766 301.912.843 298.511.169 297.322-.067 309.877.013 63.945.013c-17.645 0-32 14.355-32 32v416c0 17.645 14.355 32 32 32h302c17.645 0 32-14.355 32-32a8 8 0 00-16 0c0 8.822-7.178 16-16 16h-302c-8.822 0-16-7.178-16-16v-416c0-8.822 7.178-16 16-16h225v61c0 17.645 14.355 32 32 32h61.123v115.515c-13.043-5.236-27.215-7.882-42-7.469v-57.045c0-13.233-10.767-24-24-24h-202c-13.234 0-24 10.767-24 24v102c0 13.233 10.766 24 24 24h105a8 8 0 000-16h-36v-51h72a8 8 0 008-8v-59h53c4.411 0 8 3.589 8 8v58.727c-48.858 8.966-86 51.861-86 103.272zm82.877-229c-8.822 0-16-7.178-16-16V27.327l65.687 65.687h-49.687zm-206.877 59h53v51h-61v-43c0-4.411 3.589-8 8-8zm53 118h-53c-4.411 0-8-3.589-8-8v-43h61zm80-67h-64v-51h64zm185 119c0 49.075-39.925 89-89 89s-89-39.925-89-89 39.925-89 89-89 89 39.925 89 89zm-81 20v-3.237a7.966 7.966 0 00-5.614-7.636l-9.544-2.982c-10.074-3.148-16.842-12.354-16.842-22.907v-3.237c0-10.429 6.689-19.321 16-22.624v-3.376a8 8 0 0116 0v3.376c9.311 3.303 16 12.195 16 22.624a8 8 0 01-16 0c0-4.411-3.589-8-8-8s-8 3.589-8 8v3.237a7.966 7.966 0 005.614 7.636l9.544 2.982c10.074 3.148 16.842 12.354 16.842 22.907v3.237c0 11.519-8.159 21.165-19 23.472v2.528a8 8 0 01-16 0v-4.68c-7.713-3.996-13-12.05-13-21.32a8 8 0 0116 0c0 4.411 3.589 8 8 8s8-3.589 8-8zm-261-12a8 8 0 018-8h78a8 8 0 010 16h-78a8 8 0 01-8-8zm0 60a8 8 0 018-8h98a8 8 0 010 16h-98a8 8 0 01-8-8z" />
            </svg>
        }
        if(name == "Service Template") {
            return <svg style={{ marginRight: 10 }} version="1.1" width="24" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g>
              <path className="st0" d="M2,0h20c1.1,0,2,0.9,2,2v17.6c0,1.1-0.9,2-2,2H19v-2h2.2c0.4,0,0.7-0.3,0.7-0.7V5.1H2v13.8c0,0.4,0.3,0.7,0.7,0.7h2.2v2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0L2,0z"/>
            </g>
            <g id="_1">
              <path className="st1" d="M13.1,24h-2.2c-0.3,0-0.5-0.2-0.5-0.5L10.2,22c-0.2-0.1-0.4-0.2-0.7-0.3l-1.2,1c-0.2,0.2-0.5,0.2-0.7,0L6,21.1c-0.2-0.2-0.2-0.5,0-0.7l1-1.2c-0.1-0.2-0.2-0.4-0.3-0.7l-1.5-0.2c-0.3,0-0.5-0.3-0.5-0.5v-2.2c0-0.3,0.2-0.5,0.5-0.5l1.5-0.2c0.1-0.2,0.2-0.4,0.3-0.7L6,13c-0.2-0.2-0.2-0.5,0-0.7l1.6-1.6c0.2-0.2,0.5-0.2,0.7,0l1.2,1c0.2-0.1,0.4-0.2,0.7-0.3l0.2-1.5c0-0.3,0.3-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5l0.2,1.5c0.2,0.1,0.4,0.2,0.7,0.3l1.2-1c0.2-0.2,0.5-0.2,0.7,0l1.6,1.6c0.2,0.2,0.2,0.5,0,0.7l-1,1.2c0.1,0.2,0.2,0.4,0.3,0.7l1.5,0.2c0.3,0,0.5,0.3,0.5,0.5v2.2c0,0.3-0.2,0.5-0.5,0.5l-1.5,0.2c-0.1,0.2-0.2,0.4-0.3,0.7l1,1.2c0.2,0.2,0.2,0.5,0,0.7l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0l-1.2-1c-0.2,0.1-0.4,0.2-0.7,0.3l-0.2,1.5C13.6,23.8,13.4,24,13.1,24z"/>
              <path className="st1" d="M12,20c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3C15.3,18.5,13.8,20,12,20z M12,14.4c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C14.2,15.4,13.2,14.4,12,14.4"/>
            </g>
          </svg>
          
       
        }

        // else {
        //     return <svg style={{ marginRight: 10 }}  height={35} viewBox="0 0 512 512" width={35} fill="#5773FF" fillRule="nonzero" >
        //         <path d="M444.555 191.141h-238a7.5 7.5 0 000 15h238a7.5 7.5 0 000-15zM444.555 248.474h-238a7.5 7.5 0 000 15h238a7.5 7.5 0 000-15zM444.555 305.807h-238a7.5 7.5 0 000 15h238a7.5 7.5 0 000-15z" />
        //         <path d="M468.378 125.549H182.732c-24.053 0-43.622 19.568-43.622 43.622v179.617c0 24.053 19.568 43.622 43.622 43.622h200.211c2.141 0 4.13.963 5.458 2.644l64.655 81.853c2.548 3.226 6.266 4.984 10.159 4.984 1.447 0 2.919-.243 4.363-.745 5.327-1.85 8.769-6.689 8.769-12.328v-77.153C496.572 387.887 512 370.006 512 348.788V169.17c0-24.053-19.568-43.621-43.622-43.621zM497 348.788c0 15.577-12.673 28.412-28.25 28.61a7.5 7.5 0 00-7.404 7.5v78.305l-61.174-77.447c-4.189-5.305-10.469-8.347-17.229-8.347H182.732c-15.782 0-28.622-12.84-28.622-28.622V169.17c0-15.782 12.839-28.622 28.622-28.622h285.646c15.782 0 28.622 12.84 28.622 28.622z" />
        //         <path d="M110.494 249.561a19.997 19.997 0 00-12.936 7.435l-51.521 65.226v-65.371a7.5 7.5 0 00-7.404-7.5C25.602 249.185 15 238.448 15 225.416V69.055C15 55.852 25.742 45.11 38.945 45.11h248.663c13.203 0 23.945 10.742 23.945 23.945v28.932a7.5 7.5 0 0015 0V69.055c0-21.474-17.471-38.945-38.945-38.945H38.945C17.471 30.11 0 47.581 0 69.055v156.361c0 18.667 13.371 34.438 31.038 38.124v66.366c0 5.328 3.252 9.901 8.286 11.649 1.365.474 2.755.704 4.123.704 3.677 0 7.192-1.662 9.599-4.709l56.284-71.256a5.061 5.061 0 013.273-1.882 7.5 7.5 0 006.371-8.48 7.495 7.495 0 00-8.48-6.371z" />
        //     </svg>
        // }
    }

    let patientName = ''

    const [proxyName, setProxyName] = useState();
    // const getPatientName = (proxyArray) => {
    //     console.log(proxyArray , "ppppppppid 1")
    //     getUserId().then((userInfo) => {
    //         const item = JSON.parse(userInfo);
    //         const match = proxyArray.find(entry => 
    //             entry.resource.extension.some(ext => ext.url === 'ProxyID' && ext.valueString === item.proxyid)
    //           );
          
    //           // If a match is found, extract the name.text
    //           const result = match ? match.resource.name[0].text : 'No match found';
          
    //           setProxyName(result);
    //           setName(result)
    //           setCurrentUser(item.proxyid)

    //     })

    //     return patientName;
    // }
    const getPatientName = () => {
        setCurrentUser(PatienInformation.proxyid)
        setProxyName(PatienInformation.username)
        // getUserId().then((userInfo) => {
        //     const item = JSON.parse(userInfo);
        //     setProxyName(item.username);
        //     setCurrentUser(item.proxyid)
        //     // console.log(item.proxyid , "pppppppppid")
        //     // if (item.userid === item.parentid) {
        //     //     patientName = item.username// "Self"
        //     //     setProxyName(item.username);
        //     //     setProxyName((state) => {
        //     //         return state;
        //     //     });
        //     // }
        //     // else {
        //     //     patientName = item.username

        //     //     setProxyName(item.username);
        //     //     setProxyName((state) => {
        //     //         return state;
        //     //     });
        //     // }

        // })

        // return patientName;
    }
    const handleOk = () => {
         dispatch(appServices.Logout({PatientID: PatienInformation.parentid}))
          setOpen(false);
        //   setConfirmLoading(false);
      };
    
      const handleCancel = () => {
        setOpen(false);
      };
      const showModal = () => {
        if (buttonRef.current) {
          const buttonRect = buttonRef.current.getBoundingClientRect();
          setModalTop(buttonRect.top - 450); // 100px above the button
          setModalLeft(buttonRect.left + 10)
        }
        setIsModalVisible(true);
      };
    
      // Function to handle closing the modal
      const handleCancelModal= () => {
        setIsModalVisible(false);
      };
    return (
        <div className="sidebar">
            <ul className="navigation-menu">

                <li className="nav-category-divider">Profile View</li>
                <li>
               
                    <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                        <span >{proxyName}</span>
                        <svg style={{ marginRight: 10 }} height="25" width="25" fill="#3497FD" fillRule="nonzero" viewBox="0 0 45.532 45.532" >
                            <path d="M22.766.001C10.194.001 0 10.193 0 22.766s10.193 22.765 22.766 22.765c12.574 0 22.766-10.192 22.766-22.765S35.34.001 22.766.001zm0 6.807a7.53 7.53 0 11.001 15.06 7.53 7.53 0 01-.001-15.06zm-.005 32.771a16.708 16.708 0 01-10.88-4.012 3.209 3.209 0 01-1.126-2.439c0-4.217 3.413-7.592 7.631-7.592h8.762c4.219 0 7.619 3.375 7.619 7.592a3.2 3.2 0 01-1.125 2.438 16.702 16.702 0 01-10.881 4.013z" />
                        </svg>
                    </NavLink>
                </li>

                <li className="nav-category-divider">MAIN</li>

                <li>
                    <NavLink to='/' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                        <span >Home</span>
                        <svg style={{ marginRight: 10 }} height="25" width="25" fill="#FDC70C" fillRule="nonzero" viewBox="0 1 511 511.999" >
                            <path d="M498.7 222.695c-.016-.011-.028-.027-.04-.039L289.805 13.81C280.902 4.902 269.066 0 256.477 0c-12.59 0-24.426 4.902-33.332 13.809L14.398 222.55c-.07.07-.144.144-.21.215-18.282 18.386-18.25 48.218.09 66.558 8.378 8.383 19.44 13.235 31.273 13.746.484.047.969.07 1.457.07h8.32v153.696c0 30.418 24.75 55.164 55.168 55.164h81.711c8.285 0 15-6.719 15-15V376.5c0-13.879 11.293-25.168 25.172-25.168h48.195c13.88 0 25.168 11.29 25.168 25.168V497c0 8.281 6.715 15 15 15h81.711c30.422 0 55.168-24.746 55.168-55.164V303.14h7.719c12.586 0 24.422-4.903 33.332-13.813 18.36-18.367 18.367-48.254.027-66.633zm-21.243 45.422a17.03 17.03 0 01-12.117 5.024H442.62c-8.285 0-15 6.714-15 15v168.695c0 13.875-11.289 25.164-25.168 25.164h-66.71V376.5c0-30.418-24.747-55.168-55.169-55.168H232.38c-30.422 0-55.172 24.75-55.172 55.168V482h-66.71c-13.876 0-25.169-11.29-25.169-25.164V288.14c0-8.286-6.715-15-15-15H48a13.9 13.9 0 00-.703-.032c-4.469-.078-8.66-1.851-11.8-4.996-6.68-6.68-6.68-17.55 0-24.234.003 0 .003-.004.007-.008l.012-.012L244.363 35.02A17.003 17.003 0 01256.477 30c4.574 0 8.875 1.781 12.113 5.02l208.8 208.796.098.094c6.645 6.692 6.633 17.54-.031 24.207zm0 0" />
                        </svg>
                    </NavLink>
                </li>

                <div style={{ height: 50 }}>
                    {ProxyMenu != null && ProxyMenu != undefined && ProxyMenu.map((item) => {
                        return (
                            <li>
                                <NavLink to={menuNavigationRoute(item.resource.extension[0].valueString)} style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                                    {item.resource.id == 11 && Profile[0]?.resource?.extension[15]?.valueString && Profile[0]?.resource?.extension[15]?.valueString != "0" ? <span className='mesg-badge'>{Profile[0]?.resource?.extension[15]?.valueString}</span> : null}
                                    <span >{item.resource.extension[0].valueString }</span>
                                    {returnIcon(item.resource.extension[0].valueString)}
                                </NavLink>
                            </li>
                        )
                    })}

                    <li>
                        <NavLink to="/myCareTeam" style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                            <span >My Care Team</span>
                            <i className="mdi mdi-account link-icon" />
                        </NavLink>
                    </li>
                </div>

                {/* 
                <li>
                    <Link to="/">
                        <span className="link-title">Dashboard</span>
                        <i className="mdi mdi-gauge link-icon" />
                    </Link>
                </li>

                <li>
                    <Link to="/appointments">
                        <span className="link-title">Appointments</span>
                        <i className="mdi mdi-gauge link-icon" />
                    </Link>
                </li> 
                */}



            </ul>
          
            <div className="sidebar_footer">
            {/* <div className="user-account">
                    <div className="user-profile-item-tittle">Switch User</div>
                    <div className="user-profile-itemcategory">

                        {
                            Proxy && Proxy.length ? (
                                <FlatList
                                    data={Proxy}
                                    renderItem={({ item }) => (


                                        <View onClick={() => {
                                                    // alert("abbbb")
                                                    _setDataState(item.resource.id, item.resource.name[0].text, item.resource.extension[0].valueString)

                                                }}
                                                 style={{ margin: 6 }}>

                                            {
                                     currentUser != item.resource.id &&
                                                <div 
                                                    style={{ flex: 1, width: '100%' }}>
                                               <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                                                    <a className="user-profile-item" href="#">
                                                        <div className="avatar"><img className="profile-img img-rounded img-sm" src="https://via.placeholder.com/50" alt="profile image" /> {item.resource.name[0].text} </div>
                                                    </a>
                                                    </NavLink>
                                                </div>
                                            }
                                            {
                                                currentUser === item.resource.id &&
                                                <div style={{ flex: 1, width: '100%' }}>
                                                    <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                                                        <a className="user-profile-item" href="#">
                                                            <div className="avatar"><img className="profile-img img-rounded img-sm" src="https://via.placeholder.com/50" alt="profile image" />
                                                                {item.resource.name[0].text}
                                                                <br />
                                                                <p style={{ marginLeft: '43px' }}></p>
                                                            </div>
                                                        </a>
                                                    </NavLink>
                                                </div>
                                            }

                                        </View>

                                    )}
                                    keyExtractor={item => item.resource.id}
                                />
                            ) : !isGettlistPrpxy && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ marginTop: 10, }}>No Records Found</Text>
                            </View>
                        }

                    </div>
                    <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}><a className="user-profile-item" ><i className="mdi mdi-account" /> Profile</a></NavLink>
                    <NavLink to='/myCareTeam' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}><a className="user-profile-item" ><i className="mdi mdi-account" /> My Care Team</a></NavLink>
                    <Button 
                    loading={isLogoutLoading} type="primary" className="btn-logout"
                     onClick={() => {
                        // setOpen(true)
                        dispatch(appServices.Logout({PatientID: PatienInformation.parentid}))
                        // logoutUser()
                        }}>
                        Logout
                    </Button>
                </div> */}
            <div 
        ref={buttonRef}
        onClick={showModal}
        className="btn-group admin-access-level">
        <div className="avatar">
          <Avatar size={40} icon={<UserOutlined />} />
        </div>
        <div className="user-type-wrapper">
          <p className="user_name">{proxyName}</p>
          <div className="d-flex align-items-center">
            <div className="status-indicator small rounded-indicator bg-success" />
            <small className="user_access_level">Logged In</small>
          </div>
        </div>
        <i className={arrowClass} />
      </div>
      <Modal
        title=""      //{proxyName}
        open={isModalVisible}
        onCancel={handleCancelModal}
        width={280}
        footer={null} // Optional: Hide footer if not needed
        onOk={handleCancelModal}
        style={{ top: modalTop, left: modalLeft, position: 'absolute' }} // Custom position
        bodyStyle={{ padding: '16px' }} // Optional styling for content inside modal
      >
         <div className="user-account">
                    <div className="user-profile-item-tittle">Switch User</div>
                    <div className="user-profile-itemcategory">

                        {
                            Proxy && Proxy.length ? (
                                <FlatList
                                    data={Proxy}
                                    renderItem={({ item }) => (


                                        <View onClick={() => {
                                                    // alert("abbbb")
                                                    _setDataState(item.resource.id, item.resource.name[0].text, item.resource.extension[0].valueString)

                                                }}
                                                 style={{ margin: 6 }}>

                                            {
                                                //getCurrentUserId()
                                                //console.log("This is new ID" + currentUser)
                                                // alert(getCurrentUserId())
                                                currentUser != item.resource.id &&
                                                <div 
                                                    style={{ flex: 1, width: '100%' }}>
                                                    {/* <ProxyWebHandler
                                                        reInitails={getInitials(item.resource.name[0].text)}
                                                        reReceiverName={item.resource.name[0].text}
                                                        reType={item.resource.extension[2].valueString} /> */}
                                                        <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                                                    <a className="user-profile-item" href="#">
                                                        <div className="avatar"><img className="profile-img img-rounded img-sm" src="https://via.placeholder.com/50" alt="profile image" /> {item.resource.name[0].text} </div>
                                                    </a>
                                                    </NavLink>
                                                </div>
                                            }
                                            {
                                                currentUser === item.resource.id &&
                                                <div style={{ flex: 1, width: '100%' }}>
                                                    <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}>
                                                        <a className="user-profile-item" href="#">
                                                            <div className="avatar"><img className="profile-img img-rounded img-sm" src="https://via.placeholder.com/50" alt="profile image" />
                                                                {item.resource.name[0].text}
                                                                <br />
                                                                <p style={{ marginLeft: '43px' }}></p>
                                                            </div>
                                                        </a>
                                                    </NavLink>
                                                </div>
                                            }

                                        </View>

                                    )}
                                    keyExtractor={item => item.resource.id}
                                />
                            ) : !isGettlistPrpxy && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                                <Text style={{ marginTop: 10, }}>No Records Found</Text>
                            </View>
                        }



                    </div>
                    <NavLink to='/profile' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}
                    onClick={()=>{
                        handleCancelModal()
                    }}><a className="user-profile-item" ><i className="mdi mdi-account" /> Profile</a></NavLink>

                    <NavLink to='/myCareTeam' style={({ isActive }) => isActive ? { color: '#3497FD', fontWeight: 'bold' } : {}}
                    onClick={()=>{
                        handleCancelModal()
                    }}
                    ><a className="user-profile-item" ><i className="mdi mdi-account" /> My Care Team</a></NavLink>
                    <Popconfirm
                     title="Logout"
                     description ='Are you sure you want to Logout?'
                      //   open={open}
                      onConfirm={handleOk}
                         >
                    <Button 
                    loading={isLogoutLoading} type="primary" className="btn-logout"
                    //  onClick={() => {
                    //     // setOpen(true)
                    //     // dispatch(appServices.Logout({PatientID: PatienInformation.parentid}))
                    //     // logoutUser()
                    //     }}
                    >
                        Logout
                    </Button>
                    </Popconfirm>



                </div>
      </Modal>
            </div>
     

        </div>
    );
}



// function mapStateToProps(state) {
//     return {
//         Profile: state.Profile,
//         Proxy: state.Proxy,
//         ProxyMenu: state.ProxyMenu
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return {

//         // getProfile: () => dispatch(fetchProfileFromApi()),
//         // endUserSession: () => dispatch(LogoutUser()),
//         // getProxyAccessMenu: () => dispatch(getProxyAccessMenu()),
//         // getProxy: () => dispatch(getProxyListApi()),
//     }
// }


// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(Sidebar)
export default Sidebar
